let audioCtx = null;
let unlocked = false;

function getCtx() {
  if (!audioCtx) {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return null;
    audioCtx = new Ctx();
  }
  return audioCtx;
}

export function unlockOrderAlertSound() {
  const ctx = getCtx();
  if (!ctx) return;
  unlocked = true;
  if (ctx.state === 'suspended') ctx.resume().catch(() => {});
}

function beepBurst(ctx, baseTime, vol = 0.45) {
  const tone = (freq, start, dur, v = vol) => {
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = 'triangle';
    osc.frequency.value = freq;
    osc.connect(gain);
    gain.connect(ctx.destination);
    gain.gain.setValueAtTime(0.0001, baseTime + start);
    gain.gain.exponentialRampToValueAtTime(v, baseTime + start + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.0001, baseTime + start + dur);
    osc.start(baseTime + start);
    osc.stop(baseTime + start + dur + 0.04);
  };
  tone(740, 0, 0.16, vol);
  tone(988, 0.18, 0.16, vol);
  tone(1319, 0.36, 0.28, vol * 0.9);
}

function flashTitle(message) {
  const original = document.title;
  let n = 0;
  const t = setInterval(() => {
    document.title = n % 2 === 0 ? `🔔 ${message}` : original;
    n += 1;
    if (n > 12) {
      clearInterval(t);
      document.title = original;
    }
  }, 600);
}

/**
 * Alarma fuerte cuando llega un pedido nuevo a oficina (por aprobar).
 */
export function playNewPendingSound({ title = 'Pedido por aprobar', short = false } = {}) {
  const ctx = getCtx();
  if (!ctx) return;
  if (ctx.state === 'suspended') ctx.resume().catch(() => {});

  try {
    navigator.vibrate?.([250, 120, 250, 120, 400, 120, 250]);
  } catch {
    /* ignore */
  }

  if (!short) flashTitle(title);

  const t0 = ctx.currentTime;
  const times = short ? 1 : 4;
  for (let i = 0; i < times; i += 1) {
    beepBurst(ctx, t0 + i * 0.7, short ? 0.32 : 0.42);
  }
}

export function isOrderSoundUnlocked() {
  return unlocked && audioCtx && audioCtx.state !== 'suspended';
}
